'use strict';

angular.module('client.services').factory('classlinkService', ['$resource', '$q', 'CourseFactory', '$log', 'User', 'api_server',
  function ($resource, $q, CourseFactory, $log, User, api_server) {

    var syncResource = $resource(api_server + '/ims/courses/sync', {ims_id: '@ims_id'},
      {
        'post': {method: 'POST'}
      });

    function syncCourse(ims_id, id) {
      return syncResource.post({ims_id: ims_id}, {cid: id}).$promise;
    }

    var importableClassesResource = $resource(api_server + '/admin/licenses/users/:userId/classlink/importable-classes',
      { userId: '@userId' },
      { get: { method: 'GET' } });

    /**
     * Fetch list of ClassLink classes that are active in ClassLink and not in Exploros.
     * Called only when the user clicks "Import From ClassLink" (not on modal open).
     */
    function getImportableClasses() {
      var userId = User.getId();
      if (!userId) {
        return $q.when({ courses: [] });
      }
      return importableClassesResource.get({ userId: userId }).$promise
        .then(function (response) {
          var classes = (response && response.classes) ? response.classes : [];
          return {
            courses: classes.map(function (c) {
              var displayName = (c && (c.title || c.name || c.className || c.classTitle)) || c.classSourcedId || '';
              return {
                name: displayName,
                classSourcedId: c.classSourcedId,
                tenantId: c.tenantId,
                schoolId: c.schoolId,
                enrollmentSourcedId: c.enrollmentSourcedId
              };
            })
          };
        })
        .catch(function (error) {
          $log.error('ClassLink importable-classes error:', error);
          return { courses: [] };
        });
    }

    var importResource = $resource(api_server + '/admin/licenses/oneroster/import-class', {}, {
      post: { method: 'POST' }
    });

    function importCourse(selectedClass, params) {
      var body = {
        tenantId: selectedClass.tenantId,
        classSourcedId: selectedClass.classSourcedId,
        schoolId: selectedClass.schoolId,
        title: selectedClass.name,
        teacherId: params.teacherId,
        enrollmentSourcedId: selectedClass.enrollmentSourcedId || null
      };
      if (params.grade !== undefined && params.grade !== null) body.grade = params.grade;
      if (params.subject !== undefined && params.subject !== null) body.subject = params.subject;
      if (params.licenses !== undefined && Array.isArray(params.licenses) && params.licenses.length > 0) body.licenses = params.licenses;
      return importResource.post({}, body).$promise.then(function (res) {
        return {
          cid: res.cid,
          className: res.className,
          added: res.studentAdds,
          addedStudents: res.studentAdds,
          failedStudents: res.failedStudents,
          failedDomainStudents: res.failedDomainStudents,
          sufficientSeats: res.sufficientSeats
        };
      });
    }

    return {
      syncCourse: syncCourse,
      getImportableClasses: getImportableClasses,
      importCourse: importCourse
    };
  }]);
